import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface DealDescriptionEntityParams {
  product_id: number | string;
  discount_id: number | string;
  discount_text: string;
}
export class DealDescriptionEntity extends BaseEntityClass {
  product_id: number | string;
  discount_id: number | string;
  discount_text: string;
  constructor(params: DealDescriptionEntityParams) {
    super();
    this.type = "deal_description";
    this.entity_version = 2;
    this.product_id = params.product_id;
    this.discount_id = params.discount_id;
    this.discount_text = params.discount_text;
  }
}
